module.exports = __webpack_public_path__ + "img/sec_in_device2.c7b01ac8.png";